<div class="import-config-protocol-edit">
  <div class="protocol-header">
    <app-import-configuration-protocol-edit-form-header [protocol]="protocol"></app-import-configuration-protocol-edit-form-header>
  </div>
  <hr>
  <div class="file-handling" id="file-handling">
    <app-import-configuration-protocol-edit-form-file-handling [protocol]="protocol" (import)="import($event)"></app-import-configuration-protocol-edit-form-file-handling>
  </div>
  <hr>
  <div class="log-list">
    <app-import-configuration-protocol-edit-form-log-list [logEntries]="protocol?.logEntries" [iteration]="protocol?.currentIteration" (iterationChanged) = "onIterationChanged($event)"></app-import-configuration-protocol-edit-form-log-list>
  </div>
</div>
